export const PoolMath = {
    getPercentDifference: (totalValue: number, value: number): number => 1 - value / totalValue,
    round: (value: number, fractions = 2) => Math.round(value * Math.pow(10, fractions)) / Math.pow(10, fractions),
};
